// extracted by mini-css-extract-plugin
export var avatarContainer = "_14-0";
export var avatarTypingWave = "_14-i";
export var gray = "_14-f";
export var green = "_14-c";
export var icon = "_14-9";
export var image = "_14-1";
export var lg = "_14-6";
export var md = "_14-5";
export var presenceDot = "_14-b";
export var red = "_14-d";
export var sm = "_14-4";
export var status = "_14-a";
export var typingDot = "_14-h";
export var typingPill = "_14-g";
export var xl = "_14-7";
export var xs = "_14-3";
export var xxl = "_14-8";
export var xxs = "_14-2";
export var yellow = "_14-e";